module.exports = __webpack_public_path__ + "assets/ta-icon-39c080.svg";